import { render, staticRenderFns } from "./single-warehouse-stock.vue?vue&type=template&id=0e683173&scoped=true"
import script from "./single-warehouse-stock.vue?vue&type=script&lang=js"
export * from "./single-warehouse-stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e683173",
  null
  
)

export default component.exports